module.exports = __webpack_public_path__ + "img/image01.17e5a61e.jpg";